// src/pages/ContactPage/ContactPage.jsx
import React from 'react';
import Contact from '../../components/sections/Contact/Contact';
import Cta from '../../components/sections/Cta/Cta';
import FAQ from '../../components/sections/FAQ/FAQ';
const ContactPage = () => {
    return (
        <>
            <Contact />
            <FAQ />
            <Cta/>
        </>
    );
};

export default ContactPage;